import { createAction } from "@reduxjs/toolkit"
import TYPES from "../types"

export const setModuleData = createAction(TYPES.SET_MODULE_DATA)

export const setFilteredData = createAction(TYPES.SET_MODULE_FILTERED_DATA)

export const fetchData = ({ module }) => {
    let ACTION = ""

    switch (module) {
        default:
            ACTION = TYPES.FETCH_DRIVERS_DATA
    }

    return {
        type: ACTION,
    }
}
